/**
 * Build Formik/API role rows from the nested tree used in UserRoles.
 *
 * Prefer `assigned` over visual `checked` for modules: the tree marks parents
 * checked when any child is on (display only). Sending that as active would
 * incorrectly grant parent roles (e.g. inventory when only inventory_finance).
 *
 * @param {Array<Record<string, unknown>>} rolesTree
 * @param {{ idByName?: Record<string, unknown> }} [options]
 * @returns {{ id?: unknown, name: string, active: boolean }[]}
 */
export function buildRoleFormPayloadFromTree(rolesTree, options = {}) {
  const idByName = options.idByName || {};
  const allRoles = [];

  const pushNode = (node) => {
    if (!node?.name) return;
    const id = node.id ?? idByName[node.name];
    // Synthetic parents (ifc, human, chemical, …) have no catalog Role — omit.
    if (id == null) return;
    const active =
      node.assigned != null ? Boolean(node.assigned) : Boolean(node.checked);
    allRoles.push({ id, name: node.name, active });
  };

  (rolesTree || []).forEach((module) => {
    pushNode(module);
    (module.actions || []).forEach(pushNode);
    (module.submodules || []).forEach((submodule) => {
      pushNode(submodule);
      (submodule.actions || []).forEach(pushNode);
    });
  });
  return allRoles;
}
